import { Grid, styled } from '@mui/material';
import { PropsWithChildren } from 'react';

type Props = {
  label: string;
  direction?: 'row' | 'column';
  boldValue?: boolean;
};

const Label = styled(Grid)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

const Value = styled(Grid, {
  shouldForwardProp: (prop) => prop !== 'boldValue',
})<{ boldValue?: boolean }>(({ theme, boldValue }) => ({
  color: theme.palette.text.secondary,
  fontWeight: boldValue ? 'bold' : 'normal',
}));

const RecordRow: React.FC<PropsWithChildren<Props>> = ({
  label,
  children,
  direction = 'column',
  boldValue = true,
}) => {
  return (
    <Grid container spacing={{ xs: 0, sm: 6 }}>
      <Label size={{ xs: 12, sm: 3 }}>{label}</Label>
      <Value
        boldValue={boldValue}
        size={{ xs: 12, sm: 9 }}
        display="flex"
        flexDirection={direction}
        alignContent="center"
        alignItems={direction === 'row' ? 'center' : 'flex-start'}
        gap={direction === 'row' ? 2 : 0}
      >
        {children}
      </Value>
    </Grid>
  );
};

export default RecordRow;
